"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configurationsApi = exports.goalsApi = exports.putConfigurations = exports.getConfigurations = exports.putGoals = exports.postGoals = exports.getGoals = void 0;
const types_1 = require("../metrics/types");
const getGoals = (caller) => (options) => caller(`/api/core/reporting/accounts/${options.accountId}/tests/${options.testId}/configuration`).get();
exports.getGoals = getGoals;
const postGoals = (caller) => (options) => caller(`/api/core/reporting/accounts/${options.accountId}/tests/${options.testId}/configuration`).post(options.payload);
exports.postGoals = postGoals;
const putGoals = (caller) => (options) => caller(`/api/core/reporting/accounts/${options.accountId}/tests/${options.testId}/configurations/${options.idConfig}`).put(options.payload);
exports.putGoals = putGoals;
const getConfigurations = (caller) => async ({ accountId, configurationId }) => {
    const response = await caller(`/accounts/${accountId}/configurations/${configurationId}`).get();
    return {
        ...response,
        metrics: response.metrics.map((metric) => {
            if (metric.type === types_1.MetricType.ActionTracking) {
                return {
                    ...metric,
                    value: metric.value ? JSON.parse(metric.value) : null,
                };
            }
            return metric;
        }),
    };
};
exports.getConfigurations = getConfigurations;
const putConfigurations = (caller) => ({ accountId, payload }) => caller(`/accounts/${accountId}/configurations`).put(payload);
exports.putConfigurations = putConfigurations;
const goalsApi = (caller) => ({
    getGoals: (0, exports.getGoals)(caller),
    postGoals: (0, exports.postGoals)(caller),
    putGoals: (0, exports.putGoals)(caller),
});
exports.goalsApi = goalsApi;
const configurationsApi = (caller) => ({
    getConfigurations: (0, exports.getConfigurations)(caller),
    putConfigurations: (0, exports.putConfigurations)(caller),
});
exports.configurationsApi = configurationsApi;
//# sourceMappingURL=api.js.map